import "~/app/init.mjs";

import { setup } from "goober";
import React, { lazy } from "react";
import * as ReactDOM from "react-dom/client";
import { Route as WouterRoute, Switch, useLocation } from "wouter-preact";

import { IS_DEV } from "~/app/constants.mjs";
import type { Route } from "~/app/routes.mjs";
import { routes } from "~/app/routes.mjs";
import { cssBase } from "~/app/styles.mjs";
import { extractRouteParams, isRouteMatch } from "~/utils/router-utils.mjs";

const appRoutes = routes.filter((i) => (i as Route).component) as Array<Route>;
const Modals = lazy(() => import("~/components/Modals.js"));
const ErrorPage = lazy(() => import("~/components/ErrorPage.js"));
const ProtectedRoute = lazy(() => import("~/components/ProtectedRoute.jsx"));

setup(React.createElement);

if (IS_DEV)
  new EventSource("/esbuild").addEventListener("change", () =>
    globalThis.location.reload()
  );

function App() {
  const [location] = useLocation();
  let route, params: Record<string, string>;
  for (const i of routes) {
    if (!isRouteMatch(i.url, location)) continue;
    route = i;
    params = extractRouteParams(i.url, location);
    break;
  }
  if (route) {
    route
      .fetch?.()
      .then((promise) => promise.default(params))
      .catch(() => {});
    (route as Route).preload?.();
  }
  routes
    .find((i) => i.url === "*")
    ?.fetch?.()
    .then((promise) => promise.default())
    .catch(() => {});
  return (
    <div className={cssBase()}>
      {/* @ts-ignore */}
      <Switch>
        {appRoutes.map((route, idx) => (
          // @ts-ignore
          <WouterRoute key={idx} path={route.url}>
            {route.isAuthRequired ? (
              <React.Suspense fallback={null}>
                <ProtectedRoute>
                  {React.createElement(React.lazy(route.component))}
                </ProtectedRoute>
              </React.Suspense>
            ) : (
              <React.Suspense fallback={null}>
                {React.createElement(React.lazy(route.component))}
              </React.Suspense>
            )}
          </WouterRoute>
        ))}
        {/* @ts-ignore */}
        <WouterRoute>
          <React.Suspense fallback={null}>
            <ErrorPage />
          </React.Suspense>
        </WouterRoute>
      </Switch>
      <React.Suspense fallback={null}>
        <Modals />
      </React.Suspense>
    </div>
  );
}

const container: HTMLElement | null = document.getElementById("root");
if (container) ReactDOM.createRoot(container).render(<App />);
